import { createSlice } from "@reduxjs/toolkit";
import { showUser } from "../actions";

const initialState = {
  user: [],
  loading: false,
  errMsg: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: {
    [showUser.pending]: (state) => {
      state.loading = true;
    },
    [showUser.fulfilled]: (state, action) => {
      state.user = action.payload || [];
      state.loading = false;
    },
    [showUser.rejected]: (state, action) => {
      state.loading = false;
      state.errMsg = action.payload;
    },
  },
});

export const responseUser = (state) => state.user;

export default userSlice.reducer;
